import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button, Input,Checkbox } from '../../../node_modules/semantic-ui-react';
// import Select from 'react-select';
// import {fnSearchEmployee,fnSearchEmployeeFilter } from '../../utils';
import SelectEmployees from '../../Commons/SelectEmployees';
import FilterGroupSection, { emptyFilterGroup } from '../../Commons/FilterGroupSection';
const moment = require('moment');

// function employeeSearchlist(list){
//     var employees = [];
//     if(list !=null){
//        list.map(x =>{
//            return(
//             employees.push({label:x.LastName + ", " + x.FirstName + " " + x.MiddleName,value:x._id})
//            )
//        })
//     }
//     return employees;
// }
class TardinessModal extends Component {

    constructor(props) {
        super(props);
        var defaultState = {
            filterGroup: emptyFilterGroup(),
            fromDate: moment().startOf('day').format("YYYY-MM-DD"),
            toDate: moment().startOf('day').format("YYYY-MM-DD"),
            EmployeeIds:[],
            includeEmptyEntries:true,
            searchQuery:'',
            Employeelist:[]
        };

        const savedState = sessionStorage.getItem("TardinessFilterState");
        if (savedState) {
            try {
                this.state = { ...defaultState, ...JSON.parse(savedState) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            EmployeeIds: this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries
        };
        sessionStorage.setItem("TardinessFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            message: "from tardiness modal",
            EmployeeIds:this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries,
        };
    }

    updateEmployeeIds = (ids) =>{
        this.setState({ EmployeeIds: ids});
    }
    handleCheckChange = (e) =>{
        var includeEmptyEntries  = this.state.includeEmptyEntries;
        includeEmptyEntries = includeEmptyEntries === false ? true : false;
        this.setState({includeEmptyEntries:includeEmptyEntries});
    }
    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Report Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned eight wide column">
                            <Input type="date" label="From Date" size="mini" fluid value={this.state.fromDate} onChange={(event, data)=>{this.setState({fromDate:data.value})}} />
                        </div>
                        <div class="right floated right aligned eight wide column">
                            <Input type="date" label="To Date" size="mini" fluid value={this.state.toDate} onChange={(event, data)=>{this.setState({toDate:data.value})}} />   
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                        <label>Employee</label>
                            <SelectEmployees filterGroup={this.state.filterGroup} Ids={this.state.EmployeeIds} update={this.updateEmployeeIds.bind(this)}/>
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                        <Checkbox toggle fluid label="Include empty entries" 
                                    checked={this.state.includeEmptyEntries}
                                    onClick={this.handleCheckChange.bind(this)}/>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button positive content="Generate" onClick={this.props.onSave}></Button>
                    <Button negative content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default TardinessModal;